import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _dec2, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import Helmet from 'react-helmet';
import { initialize, reduxForm, Field } from 'redux-form';
import { signContract } from 'redux/modules/signContract';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { LoggedOutLayout } from 'containers';
import { AgreementPreview, SecondaryButton, PageHeader, Spinner } from 'components';
import { LLTextField, LLCheckbox } from 'components/FormElements';
import * as styles from './ContractSignableView.scss';
import queryString from 'query-string';

var moment = require('moment');

var ContractSignableView = (_dec = reduxForm({
  form: 'signContract'
}), _dec2 = connect(function (state) {
  return {
    user: state.auth.user,
    contract: state.contract,
    signContractError: state.signContract ? state.signContract.saveError : null
  };
}, {
  initialize: initialize,
  signContract: signContract
}), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(ContractSignableView, _Component);

  var _super = _createSuper(ContractSignableView);

  function ContractSignableView(props) {
    var _this;

    _classCallCheck(this, ContractSignableView);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.props.initialize('signContract', {
        uuid: _this.props.params.contractUuid
      });
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.signContractError && nextProps.signContractError.message === 'invalid_signature') {
        _this.setState({
          errorText: 'Your signature does not match.' + "It should be ".concat(nextProps.contract.firstName, " ").concat(nextProps.contract.lastName)
        });
      } else if (nextProps.signContractError) {
        console.error(nextProps.signContractError); // TODO: Error handler here.
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSigning", function () {
      _this.setState({
        signing: true
      });

      var data = {
        uuid: _this.props.params.contractUuid,
        signature: _this.state.signature,
        agreed: _this.state.checked,
        firstName: _this.props.contract.firstName.trim(),
        lastName: _this.props.contract.lastName.trim()
      };

      if (_this.validateSignature() && _this.state.checked) {
        _this.setState({
          errorText: ''
        });

        var contractUuid = _this.props.params.contractUuid;

        _this.props.signContract(data, _this.state.affiliatePartnerSigning).then(function () {
          var paymentDetailEntryType = _this.props.contract.paymentDetailEntryType;

          if ("".concat(paymentDetailEntryType) === '1') {
            browserHistory.push("/billing/".concat(contractUuid).concat(_this.state.affiliatePartnerSigning ? '?affiliatesign=true' : ''));
          } else {
            if (_this.state.affiliatePartnerSigning) {
              var _this$props$contract$ = _slicedToArray(_this.props.contract.Organizations, 1),
                  org = _this$props$contract$[0];

              if (org) {
                return browserHistory.push("/global/clients/".concat(org.id));
              }
            }

            browserHistory.push("/billing/signed-agreement/".concat(contractUuid));
          }
        })["catch"](function (err) {
          console.error(err);

          _this.setState({
            signing: false,
            errorText: err.message
          });
        });
      } else {
        if (!_this.validateSignature()) {
          _this.setState({
            signing: false,
            errorText: 'Your signature does not match. ' + "It should be ".concat(_this.props.contract.firstName, " ").concat(_this.props.contract.lastName)
          });
        }

        if (!_this.state.checked) {
          _this.setState({
            signing: false,
            checkboxLabelErrorStyle: {
              color: 'red'
            }
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "validateSignature", function () {
      var c = _this.props.contract;
      var entered = "".concat(_this.state.signature).replace(/ +(?= )/g, '').trim().toLowerCase();
      var expected = "".concat(c.firstName.trim(), " ").concat(c.lastName.trim()).replace(/ +(?= )/g, '').trim().toLowerCase();
      return entered === expected;
    });

    var params = queryString.parse(window.location.search);
    _this.state = {
      signing: false,
      checked: false,
      signature: '',
      errorText: '',
      checkboxLabelErrorStyle: {},
      affiliatePartnerSigning: params.affiliatesign && params.affiliatesign === 'true'
    };
    return _this;
  }

  _createClass(ContractSignableView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var contract = this.props.contract;
      var isMultilocationContract = this.props.contract.isPartner && this.props.contract.ContractPartners && this.props.contract.ContractPartners.length && this.props.contract.ContractPartners.some(function (cp) {
        return cp.partnerType === 'multilocation';
      });
      var isAffiliateContract = this.props.contract.isPartner && this.props.contract.ContractPartners && this.props.contract.ContractPartners.length && this.props.contract.ContractPartners.some(function (cp) {
        return cp.partnerType === 'affiliate';
      });
      var isAffiliateClientContract = this.props.contract.parentPartnerType === 'affiliate';
      var signatureSection = [];

      if (contract.signedAt) {
        signatureSection.push( /*#__PURE__*/React.createElement("div", {
          className: styles.signedAt
        }, 'This contract was signed on ' + "".concat(moment(contract.signedAt).format('MM/DD/YYYY'), " ") + "at ".concat(moment(contract.signedAt).format('h:mm:ss a'))));
      } else {
        signatureSection.push( /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
          label: isAffiliateContract || isMultilocationContract ? /*#__PURE__*/React.createElement("div", null, "Check this box and sign below to indicate that you agree to Likeable Local's", ' ', /*#__PURE__*/React.createElement("a", {
            target: "_blank",
            href: "/terms"
          }, "terms and conditions"), " and the ", /*#__PURE__*/React.createElement("a", {
            target: "_blank",
            href: "https://stripe.com/connect-account/legal"
          }, "Stripe Connect terms and conditions"), ".") : /*#__PURE__*/React.createElement("div", null, "Check this box and sign below to indicate that you agree to the", ' ', /*#__PURE__*/React.createElement("a", {
            target: "_blank",
            href: "/terms"
          }, "terms and conditions"), "."),
          checked: this.state.checked,
          onCheck: function onCheck() {
            _this2.setState({
              checked: !_this2.state.checked,
              checkboxLabelErrorStyle: {}
            });
          },
          labelStyle: this.state.checkboxLabelErrorStyle,
          style: {
            marginTop: 16,
            marginBottom: 8
          },
          inputStyle: isAffiliateContract || isMultilocationContract ? {
            width: 550,
            height: '50%'
          } : {
            width: 450
          }
        }), /*#__PURE__*/React.createElement(TextField, {
          value: this.state.signature,
          errorText: this.state.errorText,
          hintText: "Your Electronic Signature",
          onChange: function onChange(event) {
            _this2.setState({
              signature: event.target.value
            }, function () {
              if (_this2.state.checkboxLabelErrorStyle !== {}) {
                if (_this2.state.checked) {
                  _this2.setState({
                    checkboxLabelErrorStyle: {}
                  });
                }
              }

              if (_this2.state.errorText !== '') {
                if (_this2.validateSignature()) {
                  _this2.setState({
                    errorText: ''
                  });
                }
              }
            });
          }
        }), /*#__PURE__*/React.createElement("div", {
          className: "form-group",
          style: {
            marginTop: 50
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-xs-12",
          style: {
            minHeight: 80,
            position: 'relative'
          }
        }, this.state.signing ? /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }) : /*#__PURE__*/React.createElement(SecondaryButton, {
          onClick: this.handleSigning,
          disabled: this.state.signature === '',
          label: 'I agree to the terms and conditions'
        })))));
      }

      return /*#__PURE__*/React.createElement(LoggedOutLayout, {
        showNavBar: true
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Sign Your Agreement"
      }), /*#__PURE__*/React.createElement(AgreementPreview, {
        isAffiliateClientContract: isAffiliateClientContract,
        isAffiliateContract: isAffiliateContract,
        isMultilocationContract: isMultilocationContract,
        contract: this.props.contract,
        signatureSection: signatureSection
      })));
    }
  }]);

  return ContractSignableView;
}(Component), _defineProperty(_class2, "propTypes", {
  initialize: PropTypes.func.isRequired,
  signContract: PropTypes.func.isRequired,
  contract: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  params: PropTypes.func.isRequired,
  signContractError: PropTypes.object
}), _defineProperty(_class2, "contextTypes", {
  router: PropTypes.object.isRequired
}), _temp)) || _class) || _class);
export { ContractSignableView as default };